import React from 'react';
import {
    CloudServerOutlined, ApartmentOutlined, GlobalOutlined, DesktopOutlined, RobotOutlined, InboxOutlined,
} from '@ant-design/icons';

/**
 * Products a user can start with (welcome modal, checklist switcher, idle-account strip).
 * key = OnboardingService::PRODUCT_STEPS key; `to` = where "start" goes.
 */
export const ONB_PRODUCTS = [
    { key: 'llm', name: 'LLM API', text: 'One API key for GPT, DeepSeek and more', icon: <RobotOutlined />, to: '/llm/account' },
    { key: 'cdn', name: 'CDN', text: 'Speed up and protect a website', icon: <CloudServerOutlined />, to: '/cdn/domains/new' },
    { key: 'evm', name: 'Cloud servers', text: 'Launch a server', icon: <DesktopOutlined />, to: '/evm/vms/purchase' },
    { key: 's3', name: 'Object Storage', text: 'S3-compatible storage for files and backups', icon: <InboxOutlined />, to: '/s3' },
    { key: 'dns', name: 'DNS', text: 'Host DNS for your domain', icon: <ApartmentOutlined />, to: '/dns/zones?new=1' },
    { key: 'domain', name: 'Domains', text: 'Register a new domain', icon: <GlobalOutlined />, to: '/domain-registration/search' },
];

export const onbProduct = (key) => ONB_PRODUCTS.find((p) => p.key === key) || ONB_PRODUCTS[1];
